import { useLayoutEffect, type FC } from 'react';
import { cn } from 'src/utils/cn';

export const GlobalDraggingStyle: FC<{ isDragging: boolean }> = ({
  isDragging,
}) => {
  useLayoutEffect(() => {
    document.body.classList.toggle(cn(`cursor-grabbing!`), isDragging);
    document.body.classList.toggle(cn(`[&_*]:cursor-grabbing!`), isDragging);
  }, [isDragging]);
  return null;
};
